<template>
  <div>
    <van-pull-refresh v-model="loading" @refresh="loadData">
      <div style="padding: 0">
        <van-cell-group>
          <van-field v-model="device.name" :label="$t('名称')"  readonly />
          <van-field v-model="device.imei" label="IMEI"  readonly>
            <template #button>
              <van-button @click="copyImei"  plain type="default" size="mini">{{$t('复制')}}</van-button>
            </template>
          </van-field>
          <van-field v-model="device.iccid" label="ICCID"  readonly >
            <template #button>
              <van-button v-if="device.iccid" @click="copyIccid"  plain type="default" size="mini">{{$t('复制')}}</van-button>
            </template>
          </van-field>
          <van-field v-model="device.version" label="版本"  readonly >
            <template #button>
              <van-button v-if="device.version" @click="copyVersion"  plain type="default" size="mini">{{$t('复制')}}</van-button>
            </template>
          </van-field>
        </van-cell-group>

        <!-- WIFI信息展示 -->
        <van-cell-group v-if="wifiMacList.length > 0" style="margin-top: 10px;">
          <van-cell :title="$t('WIFI信息')" :value="`${wifiMacList.length}个`" is-link @click="showWifiDetail = !showWifiDetail">
            <template #icon>
              <van-icon name="wifi" style="margin-right: 8px;" />
            </template>
          </van-cell>
          <van-collapse v-model="activeWifiNames" v-if="showWifiDetail">
            <van-collapse-item v-for="(wifi, index) in wifiMacList" :key="index" :name="index">
              <template #title>
                <div style="display: flex; align-items: center;">
                  <van-icon name="wifi" style="margin-right: 8px; color: #1989fa;" />
                  <span style="font-weight: bold;">{{ wifi.ssid || wifi.mac }}</span>
                </div>
              </template>
              <div style="padding: 10px 0;">
                <van-cell :title="$t('MAC地址')" :value="wifi.mac" />
                <van-cell :title="$t('SSID')" :value="wifi.ssid || '-'" />
                <van-cell :title="$t('信号强度')" :value="`${wifi.signal} dBm`" />
                <van-cell :title="$t('更新时间')" :value="formatTime(wifi.createTime)" />
              </div>
            </van-collapse-item>
          </van-collapse>
        </van-cell-group>

        <!-- 蓝牙信息展示 -->
        <van-cell-group v-if="bleMacList.length > 0" style="margin-top: 10px;">
          <van-cell :title="$t('蓝牙信息')" :value="`${bleMacList.length}个`" is-link @click="showBleDetail = !showBleDetail">
            <template #icon>
              <van-icon name="bluetooth" style="margin-right: 8px;" />
            </template>
          </van-cell>
          <van-collapse v-model="activeBleNames" v-if="showBleDetail">
            <van-collapse-item v-for="(ble, index) in bleMacList" :key="index" :name="index">
              <template #title>
                <div style="display: flex; align-items: center;">
                  <van-icon name="bluetooth" style="margin-right: 8px; color: #1989fa;" />
                  <span style="font-weight: bold;">{{ ble.ssid || ble.mac }}</span>
                </div>
              </template>
              <div style="padding: 10px 0;">
                <van-cell :title="$t('MAC地址')" :value="ble.mac" />
                <van-cell :title="$t('SSID')" :value="ble.ssid || '-'" />
                <van-cell :title="$t('信号强度')" :value="`${ble.signal} dBm`" />
                <van-cell :title="$t('更新时间')" :value="formatTime(ble.createTime)" />
              </div>
            </van-collapse-item>
          </van-collapse>
        </van-cell-group>

        <!-- 无MAC信息提示 -->
<!--        <van-empty v-if="wifiMacList.length === 0 && bleMacList.length === 0 && !loading"-->
<!--                   :description="$t('暂无MAC信息')"-->
<!--                   image="search" />-->

      </div>
    </van-pull-refresh>
  </div>

<!--  <van-form>-->
<!--    <van-field-->
<!--        v-model="username"-->
<!--        name="用户名"-->
<!--        label="用户名"-->
<!--        placeholder="用户名"-->
<!--    />-->
<!--    <van-field-->
<!--        v-model="password"-->
<!--        type="password"-->
<!--        name="密码"-->
<!--        label="密码"-->
<!--        placeholder="密码"-->
<!--    />-->
<!--    <div style="margin: 16px;">-->
<!--      <van-button round block type="info" native-type="submit">提交</van-button>-->
<!--    </div>-->
<!--  </van-form>-->
</template>

<script>
import {Form, Field, Button, CellGroup, Cell, Toast, PullRefresh, Icon, Collapse, CollapseItem, Empty} from 'vant';
import {getBaseInfo, getLatestMacInfo} from "@/api/device";
import {getImei} from "@/util/session-storage-utils";
import {readCommonParam} from "@/util/session-storage-utils";

export default {
  name: "device-info",
  components:{
    [Form.name]:Form,
    [Field.name]:Field,
    [Button.name]:Button,
    [CellGroup.name]:CellGroup,
    [Cell.name]:Cell,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Empty.name]: Empty,
  },
  data(){
    return{
      device:{
        imei:"",
        name:"",
        iccid:"",
        version:""
      },
      loading:true,
      saasId:this.$route.query._saasId,
      // MAC信息相关数据
      wifiMacList: [],
      bleMacList: [],
      showWifiDetail: false,
      showBleDetail: false,
      activeWifiNames: [],
      activeBleNames: []
    }
  },
  created(){
    readCommonParam(this);
    this.url = window.location.href;
    this.loadData();
    document.title = this.$t("设备信息");
  },
  computed:{

  },
  methods:{
    copyImei(){
      this.copySpecialTopicUrl(this.device.imei,() => {
        Toast.success({message:this.$t("复制成功"),position:"top"})
      })
    },
    copyIccid(){
      this.copySpecialTopicUrl(this.device.iccid,() => {
        Toast.success({message:this.$t("复制成功"),position:"top"})
      })
    },
    copyVersion(){
      this.copySpecialTopicUrl(this.device.version,() => {
        Toast.success({message:this.$t("复制成功"),position:"top"})
      })
    },
    loadData(){
      // 加载设备基本信息
      getBaseInfo(getImei()).then((resp => {
        this.device = resp.data;
        // 加载MAC信息
        this.loadMacInfo();
      })).catch(() => {
        this.loading = false;
      });
    },
    // 加载MAC信息
    loadMacInfo(){
      const imei = getImei();
      if (!imei) {
        this.loading = false;
        return;
      }

      // 并行加载WIFI和蓝牙信息
      Promise.all([
        getLatestMacInfo(imei, 1), // 1表示WIFI
        getLatestMacInfo(imei, 2)  // 2表示蓝牙
      ]).then(([wifiResp, bleResp]) => {
        this.wifiMacList = wifiResp.data || [];
        this.bleMacList = bleResp.data || [];
        this.loading = false;
      }).catch(() => {
        // 加载MAC信息失败
        this.wifiMacList = [];
        this.bleMacList = [];
        this.loading = false;
        Toast.fail(this.$t('加载MAC信息失败'));
      });
    },
    // 格式化时间
    formatTime(timeStr) {
      if (!timeStr) return '-';
      try {
        const date = new Date(timeStr);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (error) {
        return timeStr;
      }
    },
    copySpecialTopicUrl (value,succCallback) {
      let oInput = document.createElement('input'); //创建一个隐藏input（重要！）
      oInput.value = value;    //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      if(succCallback){
        succCallback(oInput.value)
      }
    }
  }
}
</script>

<style scoped>
.mac-info-section {
  margin-top: 10px;
}

.mac-item-title {
  display: flex;
  align-items: center;
  font-weight: bold;
}

.mac-item-content {
  padding: 10px 0;
}

.mac-detail-cell {
  font-size: 14px;
}

.signal-strength {
  color: #1989fa;
  font-weight: bold;
}

.wifi-icon {
  color: #1989fa;
  margin-right: 8px;
}

.bluetooth-icon {
  color: #1989fa;
  margin-right: 8px;
}

.empty-container {
  padding: 20px;
  text-align: center;
}
</style>
